import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { titleCasePreserveAcronyms } from "./string/title-case"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Title-case skill labels; preserves segments around `/` (e.g. `AI / ML`, `C++ / Rust`). */
export function formatSkillLabel(skill: string): string {
  const s = skill.trim();
  if (!s) return s;
  return s
    .split(/\s*\/\s*/)
    .map((part) => titleCasePreserveAcronyms(part.trim()))
    .join(" / ");
}
